import { Link } from '@tiptap/extension-link'

export const LinkExtension = Link.extend({
  inclusive() {
    return false
  },
})
